import { Drawer } from '@mui/material';
import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    border-radius: 16px 16px 0px 0px;
    height: 'fit-content';
  }

  .drawer-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid ${COLOR.borderFilterInput};

    svg:hover {
      cursor: pointer;
    }
  }

  .drawer-content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .emphasis-slider {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .emphasis-slider-value {
      display: flex;
      gap: 16px;
      align-items: center;
      padding: 2px 0px;
    }
  }

  .drawer-action {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 0px 16px 16px 16px;
  }
`;
